import React from 'react';
import PropTypes from 'prop-types';
import PeekCarousel from '../PeekCarousel';
import {MarketplaceProduct} from '../Marketplace';
import Api from '../../Api';

// Possible widths of carousel
const MOBILE_MAX_WIDTH = 750;
const NORMAL_MAX_WIDTH = 1028;
const LARGE_MAX_WIDTH = 1280;
const XLARGE_MIN_WIDTH = 1281;
const ITEMS_IN_CAROUSEL = {
  mobile: 2,
  normal: 3,
  large: 4,
  xlarge: 5
};

export default class MarketplaceCarousel extends React.Component {
  static propTypes = {
    brands: PropTypes.object.isRequired,
    products: PropTypes.object.isRequired,
    retailerToken: PropTypes.string.isRequired,
    collections: PropTypes.object,
    displayOrder: PropTypes.array,
    selectCollection: PropTypes.func,
    selectProduct: PropTypes.func,
    generateProductUrl: PropTypes.func,
    minimize: PropTypes.bool
  };

  static defaultProps = {
    minimize: false
  };

  constructor(props) {
    super(props);

    this.renderMarketplaceItem = this.renderMarketplaceItem.bind(this);
    this.onResize = this.onResize.bind(this);
    this.state = {
      cart: Api.cache.getCart(),
      itemsPerSlide: 3
    };
  }

  componentWillMount() {
    Api.startListen(this, 'cart', Api.cache.eventTypes.CART_CHANGED);
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.CART_CHANGED);
  }

  renderMarketplaceItem(item) {
    const token = item.token;
    const isProduct = !!this.props.products[token];

    const cart = this.state.cart;
    let cartEntry = null;
    if (isProduct && cart && cart.cart && cart.cart.items && cart.cart.items.length > 0) {
      cartEntry = cart.cart.items.filter(cartItem => {
        return cartItem.product_token === item.token;
      });

      if (cartEntry.length === 0) cartEntry = null;
    }

    const brand = this.props.brands[item.brand_token] || this.props.brands;

    return <div key={item.token}>
      <MarketplaceProduct
        isEmployee={false}
        product={item}
        brand={brand}
        minimize={this.props.minimize}
        onClick={this.props.selectProduct}
        generateProductUrl={this.props.generateProductUrl}
        retailerToken={this.props.retailerToken}
        cartEntry={cartEntry}/>
    </div>;
  }

  onResize(windowWidth) {
    let itemsInCarousel;
    if (windowWidth <= MOBILE_MAX_WIDTH) {
      itemsInCarousel = ITEMS_IN_CAROUSEL.mobile;
    } else if (windowWidth <= NORMAL_MAX_WIDTH) {
      itemsInCarousel = ITEMS_IN_CAROUSEL.normal;
    } else if (windowWidth <= LARGE_MAX_WIDTH) {
      itemsInCarousel = ITEMS_IN_CAROUSEL.large;
    } else if (windowWidth >= XLARGE_MIN_WIDTH) {
      itemsInCarousel = ITEMS_IN_CAROUSEL.xlarge;
    }
    this.setState({
      itemsInCarousel
    });
  }

  render() {
    const settings = {
      'arrows': false,
      'infinite': false,
      'draggable': false,
      'slideWidth': 236,
      'slidesToShow': this.state.itemsInCarousel,
      'slidesToScroll': this.state.itemsInCarousel,
      'responsive': [
        {
          breakpoint: MOBILE_MAX_WIDTH + 1,
          settings: {slidesToShow: 2, slidesToScroll: 2, slideWidth: 140, draggable: true}
        }
      ]
    };

    const items = this.props.displayOrder
      .filter(token => !!(this.props.products[token] || (this.props.collections && this.props.collections[token])))
      .map(token => {
        return this.props.products[token] || this.props.collections[token];
      });

    return (<PeekCarousel items={items}
                          renderItem={this.renderMarketplaceItem}
                          settings={settings}
                          onResize={this.onResize}
                          itemsPerSlide={this.state.itemsInCarousel}/>);

  }
}


/** WEBPACK FOOTER **
 ** ./src/components/Marketplace/MarketplaceCarousel.js
 **/